export default __webpack_public_path__ + "static/media/640_private03-fr-web.c03de8e7.png";